module.exports = ['$translate', '$state', '$utils', '$ionicScrollDelegate', 'User', 'mailFolderService', 'secondAuthService', '$rootScope',
  function($translate, $state, $utils, $ionicScrollDelegate, User, mailFolderService, secondAuthService, $rootScope) {
    return {
      restrict: 'E',
      replace: true,
      scope: {
        folderItem: '=', // A wrapper for Message.
        handlerDelegate: '=', // Pass a handler object who delegates handling of selected objs.
        iconClass: '=',
      },
      template: require('views/mail/folder-item.html'),
      compile: function(element) {
        return $utils.recursionHelper.compile(element, function(scope, elem, attr) {
          scope.selectFolder = function() {
            const folderItem = scope.folderItem
            switch (folderItem.data.id) {
              case -1:
                LA.track('A1B301')
                break
              case -2:
                LA.track('A1B302')
                break
              case 1:
                LA.track('A1B303')
                break
              case -5:
                LA.track('A1B304')
                break
              case -3:
                LA.track('A1B305')
                break
              case 3:
                LA.track('A1B306')
                break
              case 4:
                LA.track('A1B307')
                break
              case 5:
                LA.track('A1B308')
                break
              case 6:
                LA.track('A1B309')
                break
            }

            // 判断文件夹是否需要解锁
            const user = User.getCurrentUser()
            if (folderItem.data.auth2Locked && !user.config.hasSecondAuthenticated) {
              console.log('进入文件夹解锁')
              secondAuthService.alertFolderUnlock(function () {
                scope.handlerDelegate.selectFolder(folderItem.data.id)
              })

              return
            }
            scope.handlerDelegate.selectFolder(folderItem.data.id)
          }
          scope.wrapFolder = function() {
            if (scope.expand) {
              scope.direction = 'icondown'
              scope.showUnreadIcon = true
            } else {
              scope.direction = 'icontop'
              scope.showUnreadIcon = false
            }
            scope.expand = !scope.expand
            $ionicScrollDelegate.resize()
          }
        })
      },
      controller: ['$scope', function($scope) {
        $scope.unreadType = $rootScope.settings.unreadType
      }]
    }
  }
]



// WEBPACK FOOTER //
// ./src/js/mail/folderItem.js